<script lang="ts">
  import Layout from '../Layout.svelte';
  import LayoutWithAnimation from '../LayoutWithAnimation.svelte';
  import Form from './Form.svelte';

  const insideIFrame = window.parent !== window;
</script>

{#if insideIFrame}
  <Layout>
    <Form insideIFrame/>
  </Layout>
{:else}
  <LayoutWithAnimation>
    <Form/>
  </LayoutWithAnimation>
{/if}
